export default function({correct}, indices){
    return correct === indices;
}